import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { ButtonModule, ListboxModule, NavButtonModule, PreloaderModule, SvgIconModule } from '@hdms/shared/ui-core';

import { HeaderUserAccountLinksComponent } from './header-user-account-links/header-user-account-links.component';
import { HeaderUserInfoButtonComponent } from './header-user-info-button/header-user-info-button.component';
import { HeaderUserNameComponent } from './header-user-name/header-user-name.component';
import { HeaderUserSelectComponent } from './header-user-select/header-user-select.component';

@NgModule({
  declarations: [
    HeaderUserAccountLinksComponent,
    HeaderUserInfoButtonComponent,
    HeaderUserNameComponent,
    HeaderUserSelectComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    ListboxModule,
    NavButtonModule,
    PreloaderModule,
    SvgIconModule,
    TranslationModule
  ],
  exports: [
    HeaderUserAccountLinksComponent,
    HeaderUserInfoButtonComponent,
    HeaderUserNameComponent,
    HeaderUserSelectComponent
  ]
})
export class HeaderUIUserModule {}
